/**
 * @generated SignedSource<<30d6dd59e48eb32e0b09c855d829380e>>
 * @relayHash a0f8161b96432dc26fc31f27c8acee2c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 53807f9a6158e6d00d6563be38f49b1e72f904d7c7709a06faf78bdff9890283

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiAdminPagesFieldsQuery } from './uiAdminPagesFieldsQuery.graphql';

const node: PreloadableConcreteRequest<uiAdminPagesFieldsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "53807f9a6158e6d00d6563be38f49b1e72f904d7c7709a06faf78bdff9890283",
    "metadata": {},
    "name": "uiAdminPagesFieldsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
